<template>
  <div class="notification-editor" v-loading="loading">
    <el-alert v-if="validationErrorExists === true" title="入力に誤りがあります。" type="error" show-icon></el-alert>
    <el-row class="destination-selector">
      <el-col :span="24">
        <h3>送信先設定</h3>
        <div class="destination-selector-cover">
          <div class="destination-selector-item">
            <h4>送信先</h4>
            <div v-if="type === 'input'">
              <div class="destination-selector-item">
                <el-checkbox v-model="notificationData.toChatworkroom01">『アドタスカル【連絡チャット】』</el-checkbox>
                <ValidationErrorMessages :errorMessageList="validationErrorData.toChatworkroom01" />
              </div>
              <div class="destination-selector-item">
                <el-checkbox v-model="notificationData.toChatworkroom02">『アドタスカル【モニター全体チャット】』</el-checkbox>
                <ValidationErrorMessages :errorMessageList="validationErrorData.toChatworkroom02" />
              </div>
              <div class="destination-selector-item">
                <el-checkbox v-model="notificationData.toChatworkroom03">『アドタスカル【先行リリース全体チャット】』</el-checkbox>
                <ValidationErrorMessages :errorMessageList="validationErrorData.toChatworkroom03" />
              </div>
              <div class="destination-selector-item">
                <el-checkbox v-model="notificationData.toPosts">お知らせ</el-checkbox>
                <ValidationErrorMessages :errorMessageList="validationErrorData.toPosts" />
              </div>
              <div class="destination-selector-item">
                <el-checkbox v-model="notificationData.toEmail">メール</el-checkbox>
                <ValidationErrorMessages :errorMessageList="validationErrorData.toEmail" />
              </div>
            </div>
            <div v-else-if="type === 'confirm'">
              <ul>
                <li v-if="notificationData.toChatworkroom01 === true">『アドタスカル【連絡チャット】』</li>
                <li v-if="notificationData.toChatworkroom02 === true">『アドタスカル【モニター全体チャット】』</li>
                <li v-if="notificationData.toChatworkroom03 === true">『アドタスカル【先行リリース全体チャット】』</li>
                <li v-if="notificationData.toPosts === true">お知らせ</li>
                <li v-if="notificationData.toEmail === true">メール</li>
              </ul>
            </div>
          </div>
          <div v-if="notificationData.toPosts === true || notificationData.toEmail === true"
            class="user-selector-cover">
            <h4>ユーザーID選択</h4>
            <ValidationErrorMessages :errorMessageList="validationErrorData.selectedUserIdList" />
            <h5>範囲選択</h5>
            <div v-if="type === 'input'" class="user-id-range-selector-cover">
              <el-input v-model="notificationData.startUserId" type="number" min="1" clearable/>
              <span class="range-separator">～</span>
              <el-input v-model="notificationData.endUserId" type="number" min="1" clearable/>
              <ValidationErrorMessages :errorMessageList="validationErrorData.startUserId" />
              <ValidationErrorMessages :errorMessageList="validationErrorData.endUserId" />
            </div>
            <div v-else-if="type === 'confirm'" class="user-id-range-selector-cover">
              <div v-if="notificationData.startUserId !== '' || notificationData.endUserId !== ''">
                <span v-if="notificationData.startUserId !== ''">{{ notificationData.startUserId }}</span>
                <span v-if="notificationData.startUserId !== '' || notificationData.endUserId !== ''" class="range-separator">～</span>
                <span v-if="notificationData.endUserId !== ''">{{ notificationData.endUserId }}</span>
              </div>
              <div v-else>指定なし</div>
            </div>
            <h5>個別選択</h5>
            <div v-if="type === 'input'" class="user-id-selector-cover">
              <el-select v-model="notificationData.selectedUserIdList" multiple placeholder="Select">
                <el-option v-for="(userData, index) in displayUserList" :key="index" :label="userData.label"
                  :value="userData.id"></el-option>
              </el-select>
            </div>
            <div v-else-if="type === 'confirm'" class="user-name-label-list">
              <div v-if="notificationData.selectedUserIdList.length > 0">
                <span v-for="(userId, index) in notificationData.selectedUserIdList" :key="index">{{
                  userNameLabel(userId) }},</span>
              </div>
              <div v-else>指定なし</div>
            </div>
            <h4>ツール利用状況</h4>
            <ValidationErrorMessages :errorMessageList="validationErrorData.toolConditionList" />
            <div class="tool-condition-selector-cover">
              <div v-if="type === 'input'">
                <div v-for="(toolData, index) in notificationData.toolConditionList" :key="index"
                  class="tool-condition-selector-item">
                  <div v-if="type === 'input'">
                    <h5>{{ $store.getters.toolData(toolData.toolId).name }}</h5>
                    <el-radio-group v-model="notificationData.toolConditionList[index].conditionId">
                      <el-radio label="0">指定なし</el-radio>
                      <el-radio label="1">現在ON</el-radio>
                    </el-radio-group>
                  </div>
                  <div v-else-if="type === 'confirm'">
                    <div v-if="toolData.conditionId === '1'">
                      <h5>{{ $store.getters.toolData(toolData.toolId).name }}</h5>
                      <span>現在ON</span>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else-if="type === 'confirm'">
                <div v-if="notificationData.toolConditionList.filter(item => item.conditionId === '1').length > 0">
                  <div v-for="(toolData, index) in notificationData.toolConditionList" :key="index">
                    <div v-if="toolData.conditionId !== '0'">
                      <h5>{{ $store.getters.toolData(toolData.toolId).name }}</h5>
                      <span v-if="toolData.conditionId === '1'">現在ON</span>
                    </div>
                  </div>
                </div>
                <div v-else>指定なし</div>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row v-if="type === 'input'" class="mail-setting-cover">
      <el-col :span="24">
        <h3>テキスト設定</h3>
        <p>※注１：「{name01}」「{name02}」部分にはそれぞれ、送信先ユーザーの「姓」「名」が入ります。任意の場所に挿入してもかまいません。</p>
        <p>※注２：「{email}」部分には、送信先ユーザーのメールアドレスが入ります。任意の場所に挿入してもかまいません。</p>
        <h4>件名</h4>
        <el-input v-model="notificationData.title" />
        <ValidationErrorMessages :errorMessageList="validationErrorData.title" />
        <!-- <h4>ヘッダー（メール用）</h4>
        <el-input v-model="notificationData.headerText" type="textarea" :autosize="{ minRows: 1 }" />
        <ValidationErrorMessages :errorMessageList="validationErrorData.headerText" /> -->
        <h4>本文</h4>
        <el-input v-model="notificationData.bodyText" type="textarea" :autosize="{ minRows: 10 }" />
        <ValidationErrorMessages :errorMessageList="validationErrorData.bodyText" />
        <!-- <h4>フッター（メール用）</h4>
        <el-input v-model="notificationData.footerText" type="textarea" :autosize="{ minRows: 10 }" />
        <ValidationErrorMessages :errorMessageList="validationErrorData.footerText" /> -->
      </el-col>
    </el-row>
    <el-row v-else-if="type === 'confirm'" class="mail-setting-cover">
      <el-col :span="24">
        <h3>テキスト設定</h3>
        <div
          v-if="notificationData.toChatworkroom01 === true || notificationData.toChatworkroom02 === true || notificationData.toChatworkroom03 === true">
          <h4>チャットワーク</h4>
          <div class="text-box">
            <div class="title-label">{{ '【' + notificationData.title + '】' }}</div>
            <br>
            <div class="body-text-label">{{ notificationData.bodyText }}</div>
          </div>
        </div>
        <div v-if="notificationData.toPosts === true">
          <h4>お知らせ</h4>
          <h5>タイトル</h5>
          <div v-if="notificationId === '0'" class="text-box">
            <div class="title-label">{{ notificationData.title }}</div>
          </div>
          <div v-else>
            <el-input v-model="notificationData.postTitle" />
            <ValidationErrorMessages :errorMessageList="validationErrorData.postTitle" />
          </div>
          <h5>本文</h5>
          <div v-if="notificationId === '0'" class="text-box">
            <div class="body-text-label">{{ notificationData.bodyText }}</div>
          </div>
          <div v-else>
            <el-input v-model="notificationData.postBodyText" type="textarea" :autosize="{ minRows: 10 }" />
            <ValidationErrorMessages :errorMessageList="validationErrorData.postBodyText" />
            <div class="button-cover">
              <el-button @click="updatePost()" type="primary" size="large">更新</el-button>
            </div>
          </div>
        </div>
        <div v-if="notificationData.toEmail === true">
          <h4>メール</h4>
          <h5>件名</h5>
          <div class="text-box">
            <div class="title-label">{{ '【アドタスカル】' + notificationData.title }}</div>
          </div>
          <h5>本文</h5>
          <div class="text-box">
            <div class="header-text-label">{{ notificationData.headerText }}</div>
            <br>
            <div class="body-text-label">{{ notificationData.bodyText }}</div>
            <br>
            <div class="footer-text-label">{{ notificationData.footerText }}</div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row v-if="notificationId === '0'" class="button">
      <el-col v-if="type === 'input'">
        <div class="button-cover">
          <el-button @click="confirm()" type="primary" size="large">確認</el-button>
          <ValidationErrorMessages :errorMessageList="validationErrorData.targetCount" />
        </div>
      </el-col>
      <el-col v-else-if="type === 'confirm'">
        <div v-if="notificationData.toPosts === true || notificationData.toEmail === true" class="target-count-label">
          <span v-if="notificationData.toPosts === true">「お知らせ」</span><span
            v-if="notificationData.toEmail === true">「メール」</span>通知対象<br>{{ targetCount }}件
        </div>
        <div class="button-cover" v-loading="sending">
          <el-button @click="type = 'input'" type="info" size="large">修正</el-button>
          <el-button @click="send()" type="primary" size="large">送信</el-button>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ValidationErrorMessages from "@/components/Ui/ValidationErrorMessages.vue";

export default {
  name: 'NotificationEditor',
  components: {
    ValidationErrorMessages,
  },
  props: {
    notificationId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      // 
      userList: [],

      // 
      loading: false,
      sending: false,

      // 
      type: 'input',
      // type: 'confirm',
      notificationData: {
        toChatworkroom01: true,
        toChatworkroom02: true,
        toChatworkroom03: true,
        toPosts: true,
        toEmail: true,
        selectedUserIdList: [],
        startUserId: "",
        endUserId: "",
        toolConditionList: [],
        title: '',
        headerText: '',
        bodyText: '',
        postTitle: '',
        postBodyText: '',
        footerText: ''
      },
      targetCount: 0,

      // 
      validationErrorExists: false,
      validationErrorData: {
        toChatworkroom01: [],
        toChatworkroom02: [],
        toChatworkroom03: [],
        toPosts: [],
        toEmail: [],
        selectedUserIdList: [],
        startUserId: [],
        endUserId: [],
        toolConditionList: [],
        title: [],
        headerText: [],
        bodyText: [],
        postTitle: [],
        postBodyText: [],
        footerText: [],
        targetCount: [],
      },
    };
  },
  created() {
    // 
    this.getUserList();

    // 
    this.getNotificationData();

    // 
    if (this.notificationId === '0') {
      this.type = 'input';
    } else {
      this.type = 'confirm';
    }
  },
  computed: {
    ...mapGetters(['apiErrorMessage', 'topPageToolList']),
    displayUserList() {
      // 
      let displayUserList = [];

      // 
      for (const userData of this.userList) {
        // 
        let emailCountText = '';
        if (userData.emailList.length > 0) {
          emailCountText = `（※${userData.emailList.length}）`;
        }

        // 
        displayUserList.push({
          id: userData.userId,
          label: `（${userData.userId}）${userData.name01}${userData.name02}${emailCountText}`
        });
      }

      // 
      return displayUserList;
    }
  },
  methods: {
    getUserList() {
      // 
      this.$axios
        .get(`${this.$store.getters.rt}/l/api/user/get-list-with-email-list`)
        .then((response) => {
          console.log(response);

          // 
          if (response.data.status === 200) {
            this.userList = response.data.list;
          } else if (response.data.status === 401) {
            alert(response.data.message);
            this.$router.push("/login");
          } else {
            alert(this.apiErrorMessage);
            return;
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getNotificationData() {
      // 
      this.loading = true;

      // 
      let notificationId = this.notificationId;
      if (this.$route.query.copy_notification_id !== undefined) {
        notificationId = this.$route.query.copy_notification_id;
      } else {
        // no action.
      }

      // 
      let parameters = "";
      parameters += `?id=${notificationId}`;
      this.$axios
        .get(`${this.$store.getters.rt}/l/api/notification/get-data${parameters}`)
        .then((response) => {
          console.log(response);

          // 
          if (response.data.status === 200) {
            this.notificationData = response.data.data;
          } else if (response.data.status === 401) {
            alert(response.data.message);
            this.$router.push("/login");
          } else {
            alert(this.apiErrorMessage);
            return;
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    confirm() {
      // 
      const params = this.getParams();
      this.$axios
        .post(`${this.$store.getters.rt}/l/api/notification/validate-data`, params)
        .then((response) => {
          console.log(response);

          // 
          if (response.data.status === 200) {
            // 
            this.validationErrorExists = false;
            this.validationErrorData.toChatworkroom01 = [];
            this.validationErrorData.toChatworkroom02 = [];
            this.validationErrorData.toChatworkroom03 = [];
            this.validationErrorData.toPosts = [];
            this.validationErrorData.toEmail = [];
            this.validationErrorData.selectedUserIdList = [];
            this.validationErrorData.startUserId = [];
            this.validationErrorData.endUserId = [];
            this.validationErrorData.toolConditionList = [];
            this.validationErrorData.title = [];
            this.validationErrorData.headerText = [];
            this.validationErrorData.bodyText = [];
            this.validationErrorData.footerText = [];
            this.validationErrorData.targetCount = [];

            // 
            this.type = 'confirm';

            // 
            this.targetCount = response.data.targetCount;

            // ページ最上部へスムーススクロール
            window.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
          } else if (
            response.data.status === 400 ||
            response.data.status === 404
          ) {
            // 
            this.validationErrorExists = true;
            this.validationErrorData = response.data.validationErrorData;

            // 400 (バリデーションエラー) はエラー表示を見せるためスクロールする。 404 はスクロールしない
            if (response.data.status === 400) {
              window.scrollTo({
                top: 0,
                behavior: 'smooth'
              });
            } else {
              // no action.
            }
          } else if (response.data.status === 401) {
            alert(response.data.message);
            this.$router.push("/login");
          } else {
            alert(this.apiErrorMessage);
            return;
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    userNameLabel(userId) {
      // 
      const userData = this.displayUserList.find(userData => userData.id === userId);

      // 
      return userData.label;
    },
    send() {
      this.sending = true;

      // 
      const params = this.getParams();
      this.$axios
        .post(`${this.$store.getters.rt}/l/api/notification/send`, params)
        .then((response) => {
          console.log(response);

          // 
          if (response.data.status === 200) {
            alert('送信しました。');
            this.$router.push("/ctrl/notifications");
          } else if (response.data.status === 400) {
            this.validationErrorData = response.data.validationErrorData;
          } else if (response.data.status === 401) {
            alert(response.data.message);
            this.$router.push("/login");
          } else {
            alert(this.apiErrorMessage);
            return;
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.sending = false;
        });
    },
    updatePost() {
      // 
      const params = new URLSearchParams();
      params.append('notification_id', this.notificationId);
      params.append('post_title', this.notificationData.postTitle);
      params.append('post_body_text', this.notificationData.postBodyText);
      this.$axios
        .post(`${this.$store.getters.rt}/l/api/notification/update-post`, params)
        .then((response) => {
          console.log(response);

          // 
          if (response.data.status === 200) {
            alert('更新しました。');
            this.$router.push("/ctrl/notifications");
          } else if (response.data.status === 401) {
            alert(response.data.message);
            this.$router.push("/login");
          } else {
            alert(this.apiErrorMessage);
            return;
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getParams() {
      // 
      const params = new URLSearchParams();
      params.append('to_chatworkroom01', this.notificationData.toChatworkroom01 === true ? '1' : '0');
      params.append('to_chatworkroom02', this.notificationData.toChatworkroom02 === true ? '1' : '0');
      params.append('to_chatworkroom03', this.notificationData.toChatworkroom03 === true ? '1' : '0');
      params.append('to_posts', this.notificationData.toPosts === true ? '1' : '0');
      params.append('to_email', this.notificationData.toEmail === true ? '1' : '0');
      params.append('selected_user_id_list', JSON.stringify(this.notificationData.selectedUserIdList));
      params.append('start_user_id', this.notificationData.startUserId);
      params.append('end_user_id', this.notificationData.endUserId);
      params.append('tool_condition_list', JSON.stringify(this.notificationData.toolConditionList));
      params.append('title', this.notificationData.title);
      params.append('header_text', this.notificationData.headerText);
      params.append('body_text', this.notificationData.bodyText);
      params.append('footer_text', this.notificationData.footerText);

      // 
      return params;
    }
  }
};
</script>

<style scoped>
.notification-editor {
  .button-cover {
    margin-top: 1.5em;
    text-align: center;
  }

  .el-row {
    h3 {
      background-color: #c6e2ff;
      padding: 0.5em 0.8em;
      border-radius: 5px;
    }

    h4 {
      font-size: 18px;
      border-left: 5px solid #c6e2ff;
      padding-left: 0.5em;
      margin-top: 2em;
    }

    &.destination-selector {
      .destination-selector-cover {
        .destination-selector-item {
          margin-top: 0.5em;

          .chatworkroom-selector-cover {
            padding-left: 1.5em;

            .chatworkroom-selector-item {
              margin-top: 0.5em;
            }
          }
        }

        .user-selector-cover {
          h5 {
            margin-bottom: 0.7em;
          }

          .user-id-range-selector-cover {
            .el-input {
              width: 120px;
            }
            .range-separator {
              margin: 0 0.5em;
            }
          }

          .user-id-selector-cover {
            .el-select {
              width: 30%;
            }
          }

          .user-name-label-list {
            margin-top: 0.5em;
          }
        }
      }
    }

    &.mail-setting-cover {
      margin-top: 2em;

      .text-box {
        border: 1px solid #c6e2ff;
        padding: 1em;
        border-radius: 5px;

        /* 入力の改行をそのまま表示する */
        /* ※ 以前は nl2br() + v-html で実現していたが、XSS の入口になるため CSS に変更した */
        .title-label,
        .header-text-label,
        .body-text-label,
        .footer-text-label {
          white-space: pre-wrap;
        }
      }
    }

    &.button {
      .target-count-label {
        margin-top: 1.5em;
        text-align: center;
      }

      .button-cover {
        margin-top: 0.7em;
      }
    }

  }

}
</style>